import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { StyleSheet, css } from 'aphrodite';

const GetInTouch = () => {
  return (
    <div className={css(styles.wrapper)}>

      <h2 className={css(styles.heading)}>Get in Touch</h2>

      <div className={css(styles.section)}>
        <p className={css(styles.label)}>Email</p>
        <a href="mailto:info@fortressrestaurant.co.za" className={css(styles.link)}>
          info@fortressrestaurant.co.za
        </a>
      </div>

      <div className={css(styles.section)}>
        <p className={css(styles.label)}>Phone</p>
        <a href="tel:0127860145" className={css(styles.link)}>
          012 786 0145
        </a>
      </div>

      <div className={css(styles.section, styles.whatsappRow)}>
        <FaWhatsapp size={20} />
        <a
          href="https://wa.me/+27694336650"
          target="_blank"
          rel="noreferrer"
          className={css(styles.link)}
        >
          WhatsApp
        </a>
      </div>

      <div className={css(styles.divider)} />

      <div className={css(styles.section)}>
        <h3 className={css(styles.subHeading)}>Address</h3>
        <p className={css(styles.text)}>194 Bancor Avenue, Ext 2</p>
        <p className={css(styles.text)}>Menlyn Maine Central Square</p>
        <p className={css(styles.text)}>Shop No. 103</p>
        <p className={css(styles.text)}>Pretoria East, South Africa, 0181</p>
      </div>

      <div className={css(styles.section)}>
        <h3 className={css(styles.subHeading)}>Opening Hours</h3>
        <p className={css(styles.text)}>Mon - Sat: 11:00 - 22:00</p>
        <p className={css(styles.text)}>Sun: 11:00 - 20:00</p>
      </div>

    </div>
  );
};

const styles = StyleSheet.create({

  wrapper: {
    backgroundColor: 'var(--color-green)',
    fontFamily: 'var(--font-alt)',
    padding: '2rem',
    borderRadius: '18px',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.2rem',
    boxShadow: 'var(--shadow-soft)',
    maxWidth: '500px',
    width: '100%',

    '@media (max-width: 768px)': {
      marginTop: '2rem',
    },
  },

  heading: {
    fontSize: '1.8rem',
    fontWeight: '700',
    color: 'var(--color-white)',
    marginBottom: '1rem',
  },

  subHeading: {
    fontSize: '1.1rem',
    fontWeight: '600',
    color: '#d8c594',
    marginBottom: '0.5rem',
  },

  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.3rem',
  },

  label: {
    fontSize: '0.9rem',
    color: 'rgba(255,253,247,.6)',
  },

  text: {
    color: 'rgba(255,253,247,.82)',
    fontSize: '0.95rem',
  },

  link: {
    color: 'var(--color-white)',
    textDecoration: 'none',
    fontSize: '0.95rem',
    transition: '0.2s ease',

    ':hover': {
      color: '#c8b289',
    },
  },

  whatsappRow: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
    gap: '0.8rem',
    color: '#25D366',
  },

  divider: {
    height: '1px',
    backgroundColor: 'rgba(255,255,255,.16)',
    margin: '0.5rem 0',
  },

});

export default GetInTouch;
